import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Gift, Trash2, Clock, Building2, Zap, Crown } from 'lucide-react';

const PLAN_COLORS = {
  trial: 'bg-slate-500',
  base: 'bg-blue-600',
  pro: 'bg-orange-500',
  business: 'bg-purple-600',
  cancelled: 'bg-red-600',
};

const PLAN_ICONS = {
  trial: Clock,
  base: Building2,
  pro: Zap,
  business: Crown,
};

export function AdminPlanDistribution({ stats }) {
  if (!stats) return null;

  return (
    <Card className="rounded-sm bg-slate-800 border-slate-700">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Plan Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-4">
          {Object.entries(stats.plans).map(([planId, count]) => {
            const PlanIcon = PLAN_ICONS[planId] || Clock;
            return (
              <div key={planId} className="flex items-center gap-3 px-4 py-3 bg-slate-700 rounded-sm">
                <div className={`h-10 w-10 ${PLAN_COLORS[planId]} rounded-sm flex items-center justify-center`}>
                  <PlanIcon className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="text-xl font-bold">{count}</p>
                  <p className="text-xs text-slate-400 capitalize">{planId}</p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}

export function AdminActiveGrants({ grants, onRevoke, formatDate }) {
  if (!grants || grants.length === 0) return null;

  return (
    <Card className="rounded-sm bg-slate-800 border-slate-700">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <Gift className="h-5 w-5 text-pink-400" />
          Active Free Grants ({grants.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {grants.map((grant, idx) => (
            <div key={idx} className="flex items-center justify-between p-3 bg-slate-700 rounded-sm">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 bg-slate-600 rounded-sm flex items-center justify-center font-bold">
                  {grant.user_name?.charAt(0).toUpperCase() || '?'}
                </div>
                <div>
                  <p className="font-medium">{grant.user_name}</p>
                  <p className="text-sm text-slate-400">{grant.user_email}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <Badge className={PLAN_COLORS[grant.plan_id]}>{grant.plan_id}</Badge>
                <span className="text-sm text-slate-400">Until {formatDate(grant.free_until)}</span>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-red-400 hover:text-red-300 hover:bg-red-900/20"
                  onClick={() => onRevoke(grant.user_email)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
